import {
  ExposureDirectionType,
  GridSpaceDataType,
  LevelType
} from 'data/types';
import { getEffectiveFootprintPolygons } from 'utils/footprint-polygons';
import { ptacLevelContext } from 'utils/ptac-unit-placement';
import { PtacLevelContext } from 'utils/ptac-unit-placement-types';
import { ptacWallOpeningsLookup } from 'utils/ptac-wall-openings';

export function ptacLevelContextFor(
  structure: LevelType[],
  level: LevelType | undefined,
  spaces: GridSpaceDataType[],
  homeOrientation?: ExposureDirectionType
): PtacLevelContext {
  const footprints = getEffectiveFootprintPolygons(level);
  return ptacLevelContext(
    spaces,
    footprints,
    ptacWallOpeningsLookup(structure, footprints, homeOrientation)
  );
}
